export default "__VITE_ASSET__$7EAoPFj__"